export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return 'O e-mail é obrigatório';
    if (!emailRegex.test(email)) return 'Por favor, insira um e-mail válido';
    return null;
};

export const validatePassword = (password) => {
    if (!password) return 'A senha é obrigatória';
    if (password.length < 8) return 'A senha deve ter pelo menos 8 caracteres';
    if (!/[A-Z]/.test(password)) return 'A senha deve conter pelo menos uma letra maiúscula';
    if (!/[a-z]/.test(password)) return 'A senha deve conter pelo menos uma letra minúscula';
    if (!/[0-9]/.test(password)) return 'A senha deve conter pelo menos um número';
    if (!/[!@#$%^&*]/.test(password)) return 'A senha deve conter pelo menos um caractere especial (!@#$%^&*)';
    return null;
};

export const validateName = (name) => {
    if (!name) return 'O nome é obrigatório';
    if (name.length < 3) return 'O nome deve ter pelo menos 3 caracteres';
    return null;
};

export const validateSignupData = (signupData) => {
    const errors = {};
    
    const emailError = validateEmail(signupData.email);
    if (emailError) errors.email = emailError;
    
    const passwordError = validatePassword(signupData.password);
    if (passwordError) errors.password = passwordError;
    
    const nameError = validateName(signupData.name);
    if (nameError) errors.name = nameError;
    
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}; 